// React libraries
import React from 'react';
import classnames from 'classnames';
// Component Style
import { useStyles } from './CheckboxStyles';
// Assets
import Checkmark from '../../icons/Checkmark/Checkmark';
export const Checkbox = (props) => {
    const classes = useStyles(props);
    const { id, type, name, value, label, style, onChange, disabled, checked, error } = props;
    const labelClasses = classnames({
        [classes.label]: true,
        [classes[type]]: type,
        [classes.disabled]: disabled,
        [classes.error]: error,
    });
    const checkMarkClasses = classnames({
        [classes.checkmark]: true,
        [classes.disabled]: disabled,
    });
    return (React.createElement("div", { style: style, id: id },
        React.createElement("input", { type: "checkbox", className: classes.input, name: name, id: `${name}-${value}`, value: value, onChange: onChange, disabled: disabled, checked: checked }),
        React.createElement("label", { className: labelClasses, htmlFor: `${name}-${value}` },
            React.createElement(Checkmark, { className: checkMarkClasses }),
            label)));
};
Checkbox.defaultProps = {
    type: "n900",
    disabled: false,
    error: false,
};
export default React.memo(Checkbox);
